/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchRuleListItem,
    SearchRuleListItemFromJSON,
    SearchRuleListItemFromJSONTyped,
    SearchRuleListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRuleListItemPaginationWrapper
 */
export interface SearchRuleListItemPaginationWrapper {
    /**
     * 
     * @type {Array<SearchRuleListItem>}
     * @memberof SearchRuleListItemPaginationWrapper
     */
    items?: Array<SearchRuleListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleListItemPaginationWrapper
     */
    totalItems?: number;
}

export function SearchRuleListItemPaginationWrapperFromJSON(json: any): SearchRuleListItemPaginationWrapper {
    return SearchRuleListItemPaginationWrapperFromJSONTyped(json, false);
}

export function SearchRuleListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(SearchRuleListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function SearchRuleListItemPaginationWrapperToJSON(value?: SearchRuleListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(SearchRuleListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


